import React, { FC } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { useFormikContext } from "formik";
import { getFormattedTime, getTime } from "../../../services/utilities/dateFormatting";
import { WizardSummaryLayout } from '../../wizard/wizard-summary-layout';

interface SummaryProps {
    onBack: (event: any) => void;
}

const Summary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div className="flex flex-col">
            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.filter)}: <span className="text-sm text-black">{translate.byKey(TranslationKeys.timeFilter)}</span></h4>
            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.time)}: <span className="text-sm text-black">{getFormattedTime(getTime(values.time))}</span></h4>
        </div>
    </WizardSummaryLayout>
}

export default Summary;